import * as React from 'react';
import { toast } from 'react-toastify';
import DriverJobsSiteDepartureQuestionsData from './DriverJobsSiteDepartureQuestions';
import type { CompletionCheck } from './models/DriverJobInterfaces';
import type { GenericList } from './models/JobSharedInterfaces';
import { useState } from 'react';

interface DriverJobsSiteDepartureCompleteQuestionsProps {
    jobType: number;        //1 = Install, 2 = Pickup, 3 Both Install and Pickup Items
    isKwikstage: boolean;   //One or more of the items is Kwikstage
    completionCheck: CompletionCheck;
    team: GenericList[];
    saveDisabled: boolean;
    back(): void;
    updateCompleteQuestionsNumber(fieldName: string, fieldValue: number): void;
    updateCompleteQuestionsText(fieldName: string, fieldValue: string): void;
    save(): void;
}

const DriverJobsSiteDepartureCompleteQuestionsData = (props: DriverJobsSiteDepartureCompleteQuestionsProps) => {
    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const back = (e: any) => {
        e.preventDefault();

        props.back();
    }

    const updateCompleteCheckNumber = (fieldName: string, fieldValue: number) => {
        props.updateCompleteQuestionsNumber(fieldName, fieldValue);
    }

    const updateCompleteCheckText = (fieldName: string, fieldValue: string) => {
        props.updateCompleteQuestionsText(fieldName, fieldValue);
    }

    const updateErrors = (updatedErrors: any) => {
        setErrors(updatedErrors);
    }

    const validate = () => {
        let errorList: any = {};
        let formIsValid = true;
        let fields = props.completionCheck;

        //Install AND Dismantle/Pickup Questions
        if (fields.swmsSiteContact < 0) {
            formIsValid = false;
            errorList["swmsSiteContact"] = "Copy of SWMS is required";
        }
        if (fields.safetySigns < 0) {
            formIsValid = false;
            errorList["safetySigns"] = "Scaffold Safety Signs is required";
        }
        if (fields.siteChecked < 0) {
            formIsValid = false;
            errorList["siteChecked"] = "Site Checked is required";
        }
        if (fields.rubbishInBin < 0) {
            formIsValid = false;
            errorList["rubbishInBin"] = "Rubbish in Bin is required";
        }
        if (fields.siteSecured < 0) {
            formIsValid = false;
            errorList["siteSecured"] = "Site Secured is required";
        }

        //Install Questions
        if (props.jobType === 1 || props.jobType === 3) {
            if (fields.scaffoldSquare < 0) {
                formIsValid = false;
                errorList["scaffoldSquare"] = "Scaffold neat/square/plumb is required";
            }
            if (fields.scaffoldGaps < 0) {
                formIsValid = false;
                errorList["scaffoldGaps"] = "Scaffold Gaps is required";
            }
            if (fields.accessPointsInstalled < 0) {
                formIsValid = false;
                errorList["accessPointsInstalled"] = "Access Points Installed is required";
            }
            if (props.isKwikstage && fields.scaffoldSupported < 0) {
                formIsValid = false;
                errorList["scaffoldSupported"] = "Scaffold Supported is required";
            }
            if (fields.handrailsChecked < 0) {
                formIsValid = false;
                errorList["handrailsChecked"] = "Handrails Checked is required";
            }
            if (fields.gapsChecked < 0) {
                formIsValid = false;
                errorList["gapsChecked"] = "Gaps Checked is required";
            }
            if (fields.fittingsSecure < 0) {
                formIsValid = false;
                errorList["fittingsSecure"] = "Fittings Secure is required";
            }
            if (fields.scaffoldCertificateSigned < 0) {
                formIsValid = false;
                errorList["scaffoldCertificateSigned"] = "Scaffold Certificate Signed is required";
            } else if (fields.scaffoldCertificateSigned === 1 && fields.scaffoldTicketSignedById < 0) {
                formIsValid = false;
                errorList["scaffoldTicketSignedById"] = "Scaffold Ticked Signed By is required";
            }

            if (fields.scaffoldTicketPhoto < 0) {
                formIsValid = false;
                errorList["scaffoldTicketPhoto"] = "Scaffold Ticket Photo is required";
            }
            if (fields.scaffoldPhotosComplete < 0) {
                formIsValid = false;
                errorList["scaffoldPhotosComplete"] = "Scaffold Photos Complete is required";
            }
        }

        //Dismantle/Pickup Questions
        if (props.jobType === 2 || props.jobType === 3) {
            if (fields.scaffoldSafeCondition < 0) {
                formIsValid = false;
                errorList["scaffoldSafeCondition"] = "Scaffold Safe Condition is required";
            }
            if (fields.scaffoldDamage < 0) {
                formIsValid = false;
                errorList["scaffoldDamage"] = "Scaffold Damage is required";
            }
            if (fields.missingEquipment < 0) {
                formIsValid = false;
                errorList["missingEquipment"] = "Missing Equipment is required";
            }
        }

        setErrors(errorList);
        return formIsValid;
    }

    const save = (e: any) => {
        e.preventDefault();

        if (validate()) {
            props.save();
        } else {
            toast.error("Fix validation errors on screen before going Next");
        }
    }

    var questions = <DriverJobsSiteDepartureQuestionsData jobType={props.jobType} isKwikstage={props.isKwikstage} completionCheck={props.completionCheck} team={props.team} errors={errors} updateCompleteQuestionsNumber={updateCompleteCheckNumber} updateCompleteQuestionsText={updateCompleteCheckText} updateErrors={updateErrors} />

    return (
        <div>
            <div className="mobileFont marginTop10 marginBottom10">
                <div className="makeitflexspacebetween marginBottom10">
                    <h2 className="mobile-margin">Job Complete</h2>
                    <i className="mobile-icon-grey fas fa-arrow-alt-circle-left mobileMenuSize" onClick={(e) => back(e)}></i>
                </div>

                {questions}

                <div className="defaultbutton__container--right marginTop10">
                    <i className={"mobile-icon-green fas fa-circle-check mobileMenuSize" + (props.saveDisabled ? " mobile-image-button--disabled" : "")} onClick={(e) => save(e)}></i>
                </div>
            </div>
        </div>
    );
}

export default DriverJobsSiteDepartureCompleteQuestionsData;